import dynamic from 'next/dynamic';

// This map is intentionally scoped to components that exist in this vendored codebase.
export const componentMap = {
	BreadCrumbs: dynamic(() => import('@shared-components-web/components/BreadCrumbs')),
	ContentTypeRichText: dynamic(() => import('@shared-components-web/components/RichText/RichText')),
	ErrorPage: dynamic(() => import('@shared-components-web/components/ErrorPage')),
	Footer: dynamic(() => import('@shared-components-web/components/Footer')),
	ImageWrapper: dynamic(() => import('@shared-components-web/components/ImageWrapper')),
	Session: dynamic(() => import('@shared-components-web/components/Session')),
} as const;

export const getComponentMapByTheme = (_themeId: string, _variant: string) => {
	return componentMap;
};
